<template>
  <div class="archive20251126" v-if="info">
    <v-container>
      <div v-for="(info, index) in info" :key="index">
        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="10" xl="8">
            <div class="heading text-h4 pl-4">{{ formatDate(info.date) }} IDRユーザフォーラム2025 発表報告</div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h8" justify="center">
          <v-col cols="8" xl="6">
            <div>
              <div class="text-h8">2025年11月26日に開催された「IDRユーザフォーラム2025」でポスター発表しました．</div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <div>
              <div class="text-h6">
                発表題目：「ローカルLLMを用いたWeb上の悩み相談の深刻度分析」<br>
                <a href="https://www.nii.ac.jp/dsc/idr/userforum/poster/IDR-UF2025_P01.pdf" target="_blank">ポスター（PDF）</a><br><br>
                発表題目：「徳島大学オンラインカウンセリング対話コーパス(TU-OCDC)-ストレス予測・感情分析のためのマルチモーダルデータセット-」<br>
                <a href="https://www.nii.ac.jp/dsc/idr/userforum/poster/IDR-UF2025_TU-OCDC.pdf" target="_blank">ポスター（PDF）</a>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <v-row class="my-4" justify="center">
                <v-col cols="12" md="8">
                    <v-img
                    :src="require(`@/assets/archives_images/20251126.png`)"
                    eager
                    ></v-img>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

      </div>
    </v-container>
  </div>
</template>

<script>
// 共通のJavaScriptファイルをインポート
import commonScript from "./common/CommonScript.js";

export default {
  mixins: [commonScript], // 共通スクリプトをミックスイン
};
</script>

<style scoped>
/* 共通のCSSファイルをインポート */
@import url("./common/CommonStyles.css");
</style>
